<div
  cdk-overlay-origin
  [attr.aria-owns]="panelOpen ? id + '-panel' : null"
  class="sim-select__trigger"
  [class.sim-select__trigger--focused]="focused"
  [class]="status()"
  (click)="toggle()"
  #origin="cdkOverlayOrigin"
  #trigger
  [id]="id"
  [ngClass]="{ 'suffix-padding': suffix(), 'prefix-padding': prefix() }"
>
  @if (prefix()) {
    <span class="wrapper prefix-wrapper">
      <ng-content *ngTemplateOutlet="prefix()" />
    </span>
  }

  <div #element class="sim-select__icon-container" *ngIf="iconUrl">
    <div class="sim-select__icon-content">
      <sim-icon [icon]="iconUrl" [color]="iconColor" sizeType="small" />
    </div>
  </div>
  <div
    [class.sim-select__select-value--padding]="!prefix()"
    class="sim-select__select-value"
    [ngSwitch]="empty"
    [attr.id]="_valueId"
  >
    <span class="sim-select__select-value--placeholder select-min-line" *ngSwitchCase="true">{{ placeholder }}</span>
    <span
      class="select-value-text flex align-items-center justify-content-space-between"
      [class.select-counter-filter]="!triggerValue"
      *ngSwitchCase="false"
    >
      @if (triggerValue) {
        <span class="sim-text-ellipsis">{{ triggerValue }}</span>
        @if (showFilterChips()) {
          <ng-container [ngTemplateOutlet]="filterChipsAction" />
        }
      } @else {
        <span class="sim-text-ellipsis">{{ placeholder }}</span>
      }
      @if (!triggerValue && filterSelected().length) {
        <ng-container
          [ngTemplateOutlet]="filterChipsAction"
          [ngTemplateOutletContext]="{ filtersLength: filterSelected().length }"
        />
      }
    </span>
  </div>

  <ng-template #filterChipsAction let-filtersLength="filtersLength">
    <lib-filter-counter
      class="select-filter--chips"
      [canClear]="true"
      (clearEvent)="filterClear()"
      [counter]="filtersLength"
    />
  </ng-template>

  @if (!readonly()) {
    <div class="sim-select__arrow-wrapper">
      <sim-icon icon="arrow_down" [color]="arrowColor" sizeType="small" />
    </div>
  }

  @if (suffix()) {
    <span class="wrapper suffix-wrapper">
      <ng-content *ngTemplateOutlet="suffix() ?? null" />
    </span>
  }
</div>
<ng-template
  cdk-connected-overlay
  cdkConnectedOverlayLockPosition
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPanelClass]="customOverlayClass"
  [cdkConnectedOverlayPush]="overlayPush"
  [cdkConnectedOverlayViewportMargin]="overlayViewportMargin"
  [cdkConnectedOverlayScrollStrategy]="_scrollStrategy"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="panelOpen"
  [cdkConnectedOverlayPositions]="_positions"
  [cdkConnectedOverlayMinWidth]="_triggerRect?.width!"
  (backdropClick)="close()"
  (attach)="_onAttached()"
  (detach)="close()"
>
  <div
    [class]="showSearchInput ? 'select-panel-wrap-expanded' : 'select-panel-wrap'"
    [style.min-width]="_triggerRect?.width + 'px'"
    (keydown)="_handleOverlayTabKeydown($event)"
  >
    <sim-form-field *ngIf="showSearchInput" (keydown)="_handleSearchKeydown($event)">
      <sim-input
        #searchInput
        i18n-placeholder="@@SEARCH_INPUT_PLACEHOLDER"
        id="select-search-input"
        [suffix]="searchSuffix"
        [value]="inputValue"
        (valueChange)="emitInputValueChanges($event)"
        placeholder="Search..."
      />
    </sim-form-field>
    <div
      #panel
      role="listbox"
      tabindex="-1"
      class="select-panel select-value-text scrollbar"
      [attr.id]="id + '-panel'"
      [attr.aria-multiselectable]="multiple"
      [attr.aria-label]="ariaLabel || null"
      [attr.aria-labelledby]="_getPanelAriaLabelledby()"
      [@transformPanel]="multiple ? 'showing-multiple' : 'showing'"
      (@transformPanel.done)="_panelDoneAnimatingStream.next($event.toState)"
      [style.transformOrigin]="_transformOrigin"
      [style.font-size.px]="_triggerFontSize"
      [style.max-height]="panelMaxHeight"
      (keydown)="_handleKeydown($event)"
    >
      <ng-content />
    </div>
    @if (showFilterButtons()) {
      <sim-filter-actions
        [count]="filterSelectedCount"
        [clearDisabled]="filterClearDisabled"
        [applyDisabled]="filterApplyDisabled"
        (clear)="filterClear()"
        (apply)="filterApply()"
      />
    }
  </div>
</ng-template>

<ng-template #searchSuffix>
  <sim-icon color="#313844" icon="search" sizeType="small" />
</ng-template>
